import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { MatSort } from '@angular/material';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';

import { RepairerDataSource } from '../dl-multi-select-repairers/repairers.datasource';
import { Repairer } from '../../../_models/repairers';
import { RepairerService } from 'app/_services/repairers.service';


@Component({
  selector: 'app-dl-multi-select-permitted-repairers',
  templateUrl: './dl-multi-select-permitted-repairers.component.html',
  styleUrls: ['./dl-multi-select-permitted-repairers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlMultiSelectPermittedRepairersComponent implements OnInit {

  filter = '';
  dataSource: RepairerDataSource;
  displayedColumns: string[] = ['name', 'id'];

  @Input() selectedIds: number[] = [];
  @Output() outputSelectedRepairers = new EventEmitter<number[]>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('multiSelectPermittedSearch') tableSearchInput: ElementRef;

  constructor(private _repairerService: RepairerService) {}

  ngOnInit() {
    if (!this.selectedIds) {
      this.selectedIds = [];
    }
    this.dataSource = new RepairerDataSource(this._repairerService);
    this.loadRepairers();
  }

  ngAfterViewInit() {
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap((event: Event) => {
          const filterValue = (event.target as HTMLInputElement).value;
          this.filter = filterValue.trim().toLowerCase();
        })
      )
      .subscribe();
  }

  public selectItem(item: Repairer) {
    if (this.isSelected(item.id)) { return; }
    this.selectedIds = [...this.selectedIds, item.id];
    this.outputSelectedRepairers.emit(this.selectedIds);
  }

  public deSelectItem(id: number) {
    this.selectedIds = this.selectedIds.filter(sid => sid !== id);
    this.outputSelectedRepairers.emit(this.selectedIds);
  }

  public selectAll() {
    this.selectedIds = this.dataSource.getAll().map(r => r.id);
    this.outputSelectedRepairers.emit(this.selectedIds);
  }

  public clearAll() {
    this.selectedIds = [];
    this.outputSelectedRepairers.emit(this.selectedIds);
  }

  public isAllSelected(): boolean {
    const all = this.dataSource.getAll();
    return all.length > 0 && all.every(r => this.isSelected(r.id));
  }

  public isSelected(id: number): boolean {
    return this.selectedIds && this.selectedIds.includes(id);
  }

  public getRepairerName(id: number): string {
    const repairer = this.dataSource.findById(id);
    return repairer ? repairer.name : String(id);
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.filter = '';
  }

  private loadRepairers() {
    let { user } = JSON.parse(localStorage.getItem('currentUser') || '{}') || { user: null };
    const custId = user.customers[0] ? user.customers[0].id : 0;
    this.dataSource.loadCustomerRepairer(custId);
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-permitted-repairers/dl-multi-select-permitted-repairers.component.ts